import React, { createContext, useContext, useEffect, useState } from 'react';
import { getToken, setToken, removeToken } from '../utils/cookieUtils';
import useUserStore, { IToken, IUser } from '../store/userStore';
import useDateStore from '../store/selectedDateStore';
import useLocationStore from '../store/locatonStore';
import useBgColorStore from '../store/bgColor';

interface AuthContextProps {
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (user: IUser, token: IToken) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { setUserDetails, clearUserDetails } = useUserStore();
  const { clearStore } = useDateStore();
  const {clearLocationStore}=useLocationStore()
  const {clearBgColorStore}=useBgColorStore()
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    console.log('check useeffect call');
    const storedAuth = getToken();
    if (storedAuth) {
      const currentTimestamp = new Date().getTime();
      const tokenExpiry = new Date(storedAuth?.token?.expiryDate).getTime();

      if (currentTimestamp < tokenExpiry) {
        setIsAuthenticated(true);
        setUserDetails(storedAuth.user, storedAuth.token);
      } else {
        setIsAuthenticated(false);
        removeToken();
        clearUserDetails();
      }
    }
    setIsLoading(false);
  }, [setUserDetails, clearUserDetails, isAuthenticated]);

  const login = (user: IUser, token: IToken) => {
    setToken({ token, user });
    setUserDetails(user, token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    removeToken();
    clearUserDetails();
    clearStore();
    clearLocationStore();
    clearBgColorStore();
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
